import * as React from "react";
export const NewTag = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={35}
    height={16}
    viewBox="0 0 35 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={35} height={16} rx={8} fill="white" />
    <rect width={35} height={16} rx={8} fill="url(#paint0_linear_1541_26636)" />
    <path
      d="M7.77 12H6.64V5H7.69L11.1 9.96V5H12.23V12H11.18L7.77 7.04V12ZM13.6552 12V5H18.2252V6.02H14.8052V7.96H17.6252V8.95H14.8052V10.98H18.3452V12H13.6552ZM20.9 12L18.91 5L20.1 4.99L21.59 10.54L23.15 5H24.24L25.76 10.54L27.26 5H28.44L26.43 12H25.09L23.66 6.85L22.25 12H20.9Z"
      fill="#393F41"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1541_26636"
        x1={3}
        y1={2}
        x2={35}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF6EC" />
        <stop offset={1} stopColor="#EBEDFF" />
      </linearGradient>
    </defs>
  </svg>
);
export default NewTag;
